import script from "./commonPagination.vue?vue&type=script&setup=true&lang=ts"
export * from "./commonPagination.vue?vue&type=script&setup=true&lang=ts"

import "./commonPagination.vue?vue&type=style&index=0&id=61312284&lang=scss"

const __exports__ = script;

export default __exports__